import React, { useState } from "react";
import "./Header.scss";
import classNames from "classnames";
import { CatalogueMegaMenuItem } from "./CatalogueMegaMenuItem";
import { CatalogueHeaderData } from "../../../../api/headerApi.types";

interface ProductCatalogueHeaderProps {
  headerModel: CatalogueHeaderData;
}

export const ProductCatalogueHeader: React.FC<ProductCatalogueHeaderProps> = ({
  headerModel,
}) => {
  const [selected, setSelected] = useState<{
    id: number | null;
    opened: boolean;
  }>({ id: null, opened: false });

  const handleClick = (
    evt: React.MouseEvent<HTMLElement>,
    id: number | null
  ) => {
    evt.preventDefault();
    if (selected?.id == id && selected?.opened) {
      setSelected({ id: id, opened: false });
      return;
    }
    setSelected({ id: id, opened: true });
  };

  const headerNavBotLinkClass = (id: number | null) =>
    classNames(
      "header-nav-bot-link",
      id === selected?.id && selected?.opened ? "active" : ""
    );

  return (
    <div className="header-desktop">
      <div className="header-top">
        {headerModel?.items?.length > 0 && (
          <ul className="header-nav-bot w-full">
            {headerModel?.items?.map((item) => (
              <li className={headerNavBotLinkClass(item.id)} key={item.id}>
                <a onClick={(evt) => handleClick(evt, item.id)}>
                  {item.linkTitle}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div
        className={classNames("header-bot", selected?.opened ? "expanded" : "")}
      >
        <CatalogueMegaMenuItem
          item={headerModel?.items?.find((item) => item.id === selected?.id)}
        />
      </div>
    </div>
  );
};
